import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import ScrollToTop from "./components/ScrollToTop"; // path as needed
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const Home = lazy(() => import("./components/Home"));
const Verify = lazy(() => import("./components/Verify"));
const ApplicationForm = lazy(() => import("./components/ApplicationForm"));
const Services = lazy(() => import("./components/Services"));
const Internships = lazy(() => import("./components/Internship"));
const About = lazy(() => import("./components/About"));
const Features = lazy(() => import("./components/Features"));
const FAQ = lazy(() => import("./components/FAQ"));
const Contact = lazy(() => import("./components/Contact"));
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const CodeOfConduct = lazy(() => import("./components/CodeOfConduct"));
const TermsAndConditions = lazy(() => import("./components/TermsAndConditions"));
const NotFound = lazy(() => import("./components/NotFound"));

const App = () => {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen bg-white flex items-center justify-center text-light-text-secondary">
            <PulseLoader color="#00B388" size={12} aria-label="Loading content" />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<ApplicationForm />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/servies" element={<Navigate to="/services" replace />} />
          <Route path="/services" element={<Services />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/verify/:internId" element={<Verify />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
};

export default App;
